export const initDeliveryDataSelects = (data) => ({
  type: "INIT_DELIVERY_DATA_SELECTS",
  payload: data,
});
